import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { threadsBackend } from './threads.backend';
import { threadsReducer } from './threads.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('threads', threadsReducer),
    BackendModule.forFeature('threads', threadsBackend),
  ],
})
export class DatastoreThreadsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/threads/threads.module.ts